import React from "react";
import { Drawer as MantineDrawer, DrawerProps } from "@mantine/core";

interface CustomDrawerProps extends Omit<DrawerProps, "styles"> {
  // Add any custom props here if needed
}

/**
 * Drawer - Themed drawer component
 * Usage: <Drawer opened={opened} onClose={close} title="Title">Content</Drawer>
 */
export const Drawer: React.FC<CustomDrawerProps> = ({
  ...props
}) => {
  return (
    <MantineDrawer
      {...props}
      styles={{
        header: {
          backgroundColor: "rgba(26, 27, 30, 0.95)",
          borderBottom: "1px solid rgba(55, 58, 64, 0.4)",
        },
        title: {
          color: "white",
          fontWeight: 600,
        },
        close: {
          color: "white",
          "&:hover": {
            backgroundColor: "rgba(249, 115, 22, 0.1)",
          },
        },
        body: {
          backgroundColor: "rgba(26, 27, 30, 0.95)",
          color: "white",
        },
        content: {
          backgroundColor: "rgba(26, 27, 30, 0.98)",
        },
      }}
    />
  );
};

export default Drawer;

